<template>
  <div>
    <div class="container-fluid m-0 p-0 mt-5">
      <div class="row justify-content-center pt-5">
        <!-- LINKS: Auswahl + Timer -->
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 center">
          <p>Themen</p>

          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="kursRadio"
              id="radioDefault1"
              v-model="Kurs"
              value="Core1"
              :disabled="laeuft"
            />
            <label class="form-check-label" for="radioDefault1">Comptia A+ Core 1</label>
          </div>

          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="kursRadio"
              id="radioDefault2"
              v-model="Kurs"
              value="Core2"
              :disabled="laeuft"
            />
            <label class="form-check-label" for="radioDefault2">Comptia A+ Core 2</label>
          </div>

          <p class="mt-4">Anzahl der Fragen</p>

          <div class="form-check" v-for="n in [10, 20, 30, 45, 60]" :key="n">
            <input
              class="form-check-input"
              type="radio"
              name="anzahlRadio"
              :id="'AnzahlFragen' + n"
              v-model.number="AnzahlFragen"
              :value="n"
              :disabled="laeuft"
            />
            <label class="form-check-label" :for="'AnzahlFragen' + n">
              {{ n }} Fragen - {{ n }} Min.
            </label>
          </div>

          <button class="btn btn-primary mt-2" @click="starten" :disabled="laeuft">
            Starten
          </button>
          <button
            class="btn btn-outline-secondary mt-2"
            @click="stoppen"
            :disabled="!laeuft"
          >
            Stop
          </button>

          <!-- Sekunden -->
          <div
            class="progress mt-5 progress-wrapper"
            role="progressbar"
            aria-label="Sekunden"
          >
            <div class="progress-bar" :style="{ width: sekundenProzent + '%' }"></div>
            <span class="progress-text">Sekunden: {{ sekunden }}/60</span>
          </div>

          <!-- Minuten -->
          <div
            class="progress mt-1 progress-wrapper"
            role="progressbar"
            aria-label="Minuten"
            :aria-valuenow="minuten"
            aria-valuemin="0"
            :aria-valuemax="AnzahlFragen"
          >
            <div
              class="progress-bar"
              :class="minutenColor"
              :style="{ width: minutenProzent + '%' }"
            ></div>
            <span class="progress-text">Minuten: {{ minuten }}/{{ AnzahlFragen }}</span>
          </div>

          <!-- optional: Fragenfortschritt -->
          <div class="progress mt-3" v-if="quizFragen.length && !quizFertig">
            <div class="progress-bar" :style="{ width: fragenProzent + '%' }">
              {{ aktuelleFrageIndex + 1 }} / {{ quizFragen.length }}
            </div>
          </div>
        </div>

        <!-- RECHTS: Frage für Frage -->
        <div class="col-xs-12 col-sm-12 col-md-10 col-lg-10 center">
          <div v-if="quizFragen.length === 0" class="alert alert-info">
            Bitte Kurs + Anzahl wählen und auf <b>Starten</b> klicken.
          </div>

          <div v-else>
            <!-- Quiz läuft -->
            <div v-if="!quizFertig && aktuelleFrage">
              <h5>Frage {{ aktuelleFrageIndex + 1 }} von {{ quizFragen.length }}</h5>

              <!-- WICHTIG: key erzwingt Neu-Render pro Frage -->
              <div class="card mt-3" :key="aktuelleFrage.id">
                <div class="card-body">
                  <div class="fw-bold mb-3">
                    {{ aktuelleFrage.question }}
                  </div>

                  <div
                    class="form-check"
                    v-for="(text, key) in aktuelleFrage.choices"
                    :key="key"
                  >
                    <input
                      class="form-check-input"
                      type="radio"
                      :name="'q_' + aktuelleFrage.id"
                      :id="'q_' + aktuelleFrage.id + '_' + key"
                      :value="key"
                      v-model="selectedChoice"
                      @change="antwortWaehlen"
                      :disabled="feedbackShown"
                    />

                    <label
                      class="form-check-label"
                      :for="'q_' + aktuelleFrage.id + '_' + key"
                    >
                      <b>{{ key }}:</b> {{ text }}
                    </label>
                  </div>

                  <div v-if="feedbackShown" class="mt-4">
                    <div
                      class="alert"
                      :class="currentAnswerCorrect ? 'alert-success' : 'alert-danger'"
                    >
                      <div class="fw-bold mb-2">
                        {{ currentAnswerCorrect ? '✅ Richtig' : '❌ Falsch' }}
                      </div>

                      <div>
                        <b>Deine Antwort:</b>
                        {{ selectedChoice }} – {{ aktuelleFrage.choices[selectedChoice] }}
                      </div>

                      <div class="mt-1">
                        <b>Richtige Antwort:</b>
                        {{ aktuelleFrage.correct }} – {{ aktuelleFrage.choices[aktuelleFrage.correct] }}
                      </div>

                      <div class="mt-2">
                        <b>Begründung:</b>
                        {{ aktuelleFrage.explanation }}
                      </div>
                    </div>

                    <button class="btn btn-primary" @click="naechsteFrage">
                      {{ aktuelleFrageIndex < quizFragen.length - 1 ? 'Nächste Frage' : 'Test abschließen' }}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Quiz fertig -->
            <div v-else class="mt-3">
              <div class="alert" :class="statusClass">
                <h4 class="mb-1">Test beendet</h4>

                <div class="fw-bold">
                  {{ statusText }}
                </div>

                <p class="mb-1">
                  Du hast <b>{{ richtigeAntworten }}</b> von
                  <b>{{ quizFragen.length }}</b> richtig ({{ prozentRichtig }}%).
                </p>

                <p class="mb-0">
                  Bestehen ab <b>{{ bestehensProzent }}%</b> =
                  <b>{{ mindestensRichtigZumBestehen }}</b> richtige Antworten.
                </p>
              </div>

              <!-- Falsch beantwortete Fragen -->
              <div v-if="falschBeantwortete.length" class="mt-3">
                <h5 class="mb-2">
                  Falsch beantwortete Fragen ({{ falschBeantwortete.length }})
                </h5>

                <div v-for="(q, i) in falschBeantwortete" :key="q.id" class="card mb-3">
                  <div class="card-body">
                    <div class="fw-bold">{{ i + 1 }}. {{ q.question }}</div>

                    <div class="mt-2">
                      <div>
                        <b>Deine Antwort:</b>
                        <span v-if="q.given">
                          {{ q.given }} – {{ q.choices[q.given] }}
                        </span>
                        <span v-else class="text-muted">keine Antwort</span>
                      </div>

                      <div class="mt-1">
                        <b>Richtig:</b> {{ q.correct }} – {{ q.choices[q.correct] }}
                      </div>

                      <div class="mt-2 text-muted">
                        <small>{{ q.explanation }}</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-else class="alert alert-info mt-3">
                Keine falsch beantworteten Fragen 🎉
              </div>

              <button class="btn btn-primary mt-2" @click="neuStarten">
                Neu starten
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <stickybarTelMail />
  </div>
  <stickyPfeil />
</template>

<script>
import fragenkatalog from "@/assets/Fragenkatalog/CompTIA_Aplus.json";

export default {
  name: "MainPage",

  data() {
    return {
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,

      Kurs: "Core1",
      AnzahlFragen: 10,

      // Progresswerte
      sekunden: 0, // 0..60 (loop)
      minuten: 0, // 0..AnzahlFragen (stop)

      // Timer
      laeuft: false,
      sekundenTimerId: null,
      minutenTimerId: null,

      // Quiz
      quizFragen: [],
      answers: {}, // { [id]: "A"|"B"|"C"|"D" }
      aktuelleFrageIndex: 0,
      quizFertig: false,

      // Auswahl pro aktueller Frage (wichtig für Reset!)
      selectedChoice: null,
      feedbackShown: false,
    };
  },

  computed: {
    sekundenProzent() {
      return (this.sekunden / 60) * 100;
    },
    minutenProzent() {
      const max = Number(this.AnzahlFragen) || 1;
      return (this.minuten / max) * 100;
    },
    minutenColor() {
      const max = Number(this.AnzahlFragen) || 1;
      const p = this.minuten / max;

      if (p >= 0.9) return "bg-danger"; // rot
      if (p >= 0.7) return "bg-warning"; // gelb
      return "bg-success"; // grün
    },

    aktuelleFrage() {
      return this.quizFragen[this.aktuelleFrageIndex] || null;
    },

    fragenProzent() {
      if (!this.quizFragen.length) return 0;
      return ((this.aktuelleFrageIndex + 1) / this.quizFragen.length) * 100;
    },

    richtigeAntworten() {
      let r = 0;
      for (const q of this.quizFragen) {
        if (this.answers[q.id] === q.correct) r++;
      }
      return r;
    },
    falschBeantwortete() {
      return this.quizFragen
        .filter((q) => this.answers[q.id] !== q.correct)
        .map((q) => ({
          ...q,
          given: this.answers[q.id] ?? null,
        }));
    },
    prozentRichtig() {
      if (!this.quizFragen.length) return 0;
      return Math.round((this.richtigeAntworten / this.quizFragen.length) * 100);
    },

    currentAnswerCorrect() {
      if (!this.aktuelleFrage || this.selectedChoice === null) return false;
      return this.selectedChoice === this.aktuelleFrage.correct;
    },

    bestehensProzent() {
      return 75; // Empfehlung für CompTIA-Style Training
    },

    mindestensRichtigZumBestehen() {
      if (!this.quizFragen.length) return 0;
      return Math.ceil((this.bestehensProzent / 100) * this.quizFragen.length);
    },

    statusText() {
      const p = this.prozentRichtig;

      if (p >= 90) return "🏆 Excellent";
      if (p >= this.bestehensProzent) return "✅ Bestanden";
      if (p >= 70) return "⚠️ Knapp daneben";
      return "❌ Nicht bestanden";
    },

    statusClass() {
      const p = this.prozentRichtig;

      if (p >= 90) return "alert-success";
      if (p >= this.bestehensProzent) return "alert-success";
      if (p >= 70) return "alert-warning";
      return "alert-danger";
    },
  },

  watch: {
    AnzahlFragen() {
      // Minutenanzeige resetten (optional)
      this.minuten = 0;

      // wenn bereits läuft, sauber neu starten
      if (this.laeuft) {
        this.stoppen();
        this.starten();
      }
    },
  },

  methods: {
    starten() {
      if (this.laeuft) return;
      this.laeuft = true;

      // Timer/Progress reset
      this.sekunden = 0;
      this.minuten = 0;

      // Quiz reset
      this.answers = {};
      this.quizFertig = false;
      this.aktuelleFrageIndex = 0;
      this.selectedChoice = null;
      this.feedbackShown = false;

      // Fragenpool
      const pool = fragenkatalog.questions.filter((q) => q.core === this.Kurs);
      const n = Math.min(Number(this.AnzahlFragen), pool.length);
      const shuffled = this.shuffle([...pool]);
      this.quizFragen = shuffled.slice(0, n);

      // Sekunden: jede Sekunde +1, bei 60 -> 0
      this.sekundenTimerId = window.setInterval(() => {
        this.sekunden = this.sekunden >= 60 ? 0 : this.sekunden + 1;
      }, 1000);

      // Minuten: jede Minute +1 bis AnzahlFragen, dann Quiz beenden
      this.minutenTimerId = window.setInterval(() => {
        const max = Number(this.AnzahlFragen) || 0;

        if (this.minuten >= max) {
          this.quizFertig = true;
          this.stoppen();
          return;
        }
        this.minuten += 1;
      }, 60000);
    },

    neuStarten() {
      this.stoppen();
      this.quizFragen = [];
      this.answers = {};
      this.quizFertig = false;
      this.aktuelleFrageIndex = 0;
      this.selectedChoice = null;
      this.feedbackShown = false;
    },

    antwortWaehlen() {
      const q = this.aktuelleFrage;
      if (!q || this.quizFertig || this.feedbackShown) return;

      // speichern und direkt Lösung anzeigen
      this.answers[q.id] = this.selectedChoice;
      this.feedbackShown = true;
    },

    naechsteFrage() {
      if (this.aktuelleFrageIndex < this.quizFragen.length - 1) {
        this.aktuelleFrageIndex += 1;
        this.selectedChoice = null;
        this.feedbackShown = false;
      } else {
        this.quizFertig = true;
        this.feedbackShown = false;
        this.stoppen();
      }
    },

    shuffle(arr) {
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
      }
      return arr;
    },

    stoppen() {
      this.laeuft = false;

      if (this.sekundenTimerId) {
        clearInterval(this.sekundenTimerId);
        this.sekundenTimerId = null;
      }
      if (this.minutenTimerId) {
        clearInterval(this.minutenTimerId);
        this.minutenTimerId = null;
      }
    },
  },

  mounted() {
    window.onresize = () => {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;
    };
  },

  beforeUnmount() {
    this.stoppen();
  },
};
</script>

<style scoped>
.progress-wrapper {
  position: relative;
}
.progress-text {
  position: absolute;
  width: 100%;
  text-align: center;
  font-weight: bold;
  line-height: 18px;
  color: black;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}
.progress-bar {
  transition: width 0.5s ease, background-color 0.5s ease;
}
</style>
